import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpResponse,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { Router } from '@angular/router';
import { IForgotPassword } from '../models/forgotpasswordInput';
import { ResultOutputModel } from '../models/resultOutputModel';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class ForgotPasswordService {
  readonly BaseUrl = environment.base_url;
  //_user: Observable<ResultOutputModel>;
  checkEmailResponse = {} as ResultOutputModel;

  constructor(private _http: HttpClient, private router: Router) {}

  checkEmail(
    forgotPasswordModel: IForgotPassword
  ): Observable<ResultOutputModel> {
    return this._http
      .post<ResultOutputModel>(
        this.BaseUrl + '/user/checkemail',
        forgotPasswordModel
      )
      .pipe(
        map((response) => {
          this.checkEmailResponse = response;
          return this.checkEmailResponse;
        })
      );
  }
  checkConfirmationcode(
    forgotPasswordModel: IForgotPassword
  ): Observable<ResultOutputModel> {
    return this._http
      .post<ResultOutputModel>(
        this.BaseUrl + '/user/confirmationcode',
        forgotPasswordModel
      )
      .pipe(
        map((response) => {
          this.checkEmailResponse = response;
          return this.checkEmailResponse;
        })
      );
  }
  resetPassword(forgotPasswordModel: IForgotPassword) {
    return this._http
      .post<boolean>(this.BaseUrl + '/user/resetpassword', forgotPasswordModel)
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
}
